import { color } from './color';

const border = {
  secondary: `1px solid ${color.secondary}`,
  primary: `1px solid ${color.primary}`,
  default: `1px solid ${color.medium}`,
  black: `1px solid ${color.dark}`,
  white: `1px solid ${color.white}`,
  light: `1px solid ${color.light}`,
  medium: `1px solid ${color.medium}`,
  dark: `1px solid ${color.dark}`,
}

export default border;
export {border}
